import {z} from 'zod'

import {
  CreateOrUpdateBlockAccordionDocument,
  getPanel,
  updatePanel,
} from '@sdox/api'

import {EditorFeature} from '../../../../inputs/TipTap/types'
import {updateMetaSchema} from '../../utils/getUpdateMetaFromFieldValues'
import {createFormConfig} from '../../utils/createFormConfig'
import {i18nValidation} from '../../../../../i18n'

import type {BlockAccordionSectionInput, PanelFragment,
  CreateOrUpdateBlockAccordionMutation} from '@sdox/api'

type UpdateAccordionValidatorSchema = z.infer<typeof updateAccordionValidatorSchema>

const updateAccordionValidatorSchema = z.object({
  data: z.array(
    z.object({
      label: z.string().min(1, {message: i18nValidation.enterText}),
      id: z.string().optional(),
    }).required(),
  ),
  meta: updateMetaSchema,
})

export const accordionConfig = createFormConfig<
  UpdateAccordionValidatorSchema,
  CreateOrUpdateBlockAccordionMutation,
  BlockAccordionSectionInput[]
>({
  mutationOptions: {
    mutation: CreateOrUpdateBlockAccordionDocument,
    afterUpdate({data}, client) {
      if (!data) return
      data.createOrUpdateBlock.sections.forEach((section) => {
        let panel: PanelFragment | undefined
        try {
          panel = getPanel(section.panel.id, client)
        } catch (e) {/* do nothing */}
        updatePanel(
          section.panel.id,
          {
            id: section.panel.id,
            blocks: panel ? [...panel.blocks] : [],
            __typename: 'PanelType',
          },
          client,
        )
      })
    },
  },
  fieldMapper: (fieldValues) => {
    if (!Array.isArray(fieldValues.data)) {
      throw new Error('field values must have a data array')
    }
    return fieldValues.data.map((item) => ({
      label: item.label,
      id: item.id || undefined,
    }))
  },
  validatorSchema: updateAccordionValidatorSchema,
  inputFields: [
    {
      inputType: 'array',
      fieldName: 'data',
      label: 'Abschnitt',
      required: true,
      fields: [
        {
          label: 'Label',
          fieldName: 'label',
          inputType: 'richtext',
          editorConfig: {
            isSmall: true,
            spanAsParagraph: true,
            features: [
              EditorFeature.nobreak,
              EditorFeature.footnote,
            ],
          },
          defaultValue: '',
          required: true,
        },
        {
          label: 'ID',
          fieldName: 'id',
          inputType: 'hidden',
          required: true,
          defaultValue: '',
        },
      ],
    },
  ],
})
